export class CommonSettings {
  Settings: CommonSetting[];

  constructor(settings: CommonSetting[] = []) {
    this.Settings = settings;
  }
}

export class CommonSetting {
  ID: number;
  Key: string;
  Value: string;
  IsActive: boolean;
  IsDevOnly: boolean;
  Description: string;
  DataType: string;
  DataSource: string;
  OrgId: number;
  UnitId?: number;

  // Track if the setting has been modified
  isDirty: boolean = false;
  // Track validation state
  isValid: boolean = true;
  // Error message for validation
  validationError: string = '';

  constructor(data?: Partial<CommonSetting>) {
    this.ID = data?.ID || 0;
    this.Key = data?.Key || '';
    this.Value = data?.Value || '';
    this.IsActive = data?.IsActive ?? true;
    this.IsDevOnly = data?.IsDevOnly ?? false;
    this.Description = data?.Description || '';
    this.DataType = data?.DataType || 'text';
    this.DataSource = data?.DataSource || '';
    this.OrgId = data?.OrgId || 0;
    this.UnitId = data?.UnitId;
    this.isDirty = false;
    this.isValid = true;
    this.validationError = '';
  }

  /**
   * Validate the setting value based on data type
   */
  validate(): boolean {
    this.validationError = '';

    switch (this.DataType?.toLowerCase()) {
      case 'number':
      case 'integer':
        if (this.Value && isNaN(Number(this.Value))) {
          this.validationError = 'Value must be a number';
          this.isValid = false;
          return false;
        }
        break;

      case 'email':
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (this.Value && !emailRegex.test(this.Value)) {
          this.validationError = 'Invalid email format';
          this.isValid = false;
          return false;
        }
        break;

      case 'url':
        try {
          new URL(this.Value);
        } catch {
          this.validationError = 'Invalid URL format';
          this.isValid = false;
          return false;
        }
        break;

      case 'date':
        if (this.Value && isNaN(Date.parse(this.Value))) {
          this.validationError = 'Invalid date format';
          this.isValid = false;
          return false;
        }
        break;
    }

    this.isValid = true;
    return true;
  }

  /**
   * Mark setting as modified
   */
  markDirty(): void {
    this.isDirty = true;
  }

  /**
   * Mark setting as pristine
   */
  markPristine(): void {
    this.isDirty = false;
  }

  /**
   * Create a copy of the setting
   */
  clone(): CommonSetting {
    const cloned = new CommonSetting(this);
    cloned.isDirty = this.isDirty;
    cloned.isValid = this.isValid;
    cloned.validationError = this.validationError;
    return cloned;
  }
}
